<template>
  <v-card
    light
    class="mb-2"
  >
    <div class="amount text-right">
      <span>{{ $t('words.amount') }}</span>
      <div v-show="info != null">
        {{ info }}
      </div>
      <span>{{ $amount() }}</span>
    </div>

    <div
      v-show="text != null"
      class="amount-info-sup"
    >
      {{ text }}
    </div>
  </v-card>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { $amount } from '@/modules/Utils'

export default {
  name: 'Amount',

  props: {
    btnTitle: { type: String, default: null },
    text: { type: String, default: null },
    info: { type: String, default: null }
  },

  data () {
    return {
      IconEnum,
      dialog: false
    }
  },

  methods: {
    $amount
  }
}
</script>

<style lang="scss" scoped>
.amount {
  padding-top: 20px;

  & span:first-child {
    float: left;
    font-weight: 500;
    margin-left: 8px;
    margin-top: -16px;
  }

  & div {
    position: absolute;
    top: 2px;
    right: 4px;
    border: 1px solid red;
    padding: 2px 4px 0 4px;
    font-weight: 800;
    color: red;
  }

  & span:last-child {
    font-size: 40px;
    font-weight: 700;
    padding-right: 8px;
    white-space: nowrap;
  }
}

.amount-info-sup {
  font-size: 12px;
  padding-top: 2px;
  padding-left: 8px;
  background: linear-gradient(33deg, #444346, #90898e) top no-repeat;
  background-size: 95% 2px;
}

.btn-list {
  position: absolute;
  top: 25px;
  left: 0;
  color: black;
}
</style>
